import $ from 'jquery'

const $dropdowns = $('.is-style-blog-posts h2')

$dropdowns.on('click', function() {
    $(this).parent().find('ul').fadeToggle()
    $(this).toggleClass('is-active')
})